let place_holder = document.querySelectorAll('.shopify-section .placeholder-svg')
if (place_holder.length !== 0){
  let father1 = document.querySelectorAll('#shopify-section-template--18510692843735__image_with_text_imDCAn')
  let f1_id = father1[0].id
  let father2 = document.querySelectorAll('#shopify-section-template--18510692843735__image_with_text_BgWLCT')
  let f2_id = father2[0].id
  // let arr = [f1_id,f2_id]
  if (place_holder.length !== 0){
      for (let k=0;k<place_holder.length;k++){
        if (place_holder[k].parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.id === f1_id){
          father1[0].style.display = 'none'
      }else if (place_holder[k].parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.id === f2_id){
          father2[0].style.display = 'none'
      }
    }
  }  
}
